module.exports = __webpack_public_path__ + "img/aeroland-branding-image-both-laptop.f75dbf02.png";